<ng-container *ngLet=" (dprDetails$ | async) as dprDetails">
  <ng-container
    *ngLet="((selectedSubproject$ | async)?.data?.statusTrackers | filterByProperty : 'isActive': true) as statusTrackers;"
  >
    <ng-container *ngIf="statusTrackers?.length; else noStatusTrackers">
      <app-horizontal-navigation *ngIf="(screenSizeService.isHandset$ | async) === false; else handsetTemplate">
        <div *ngIf="statusTrackers?.length ; else noStatusTrackers" class="customHorizontalNavContainer">
          <button
            *ngFor="let item of statusTrackers; trackBy: trackStatusTracker"
            mat-flat-button
            class="mr-2 horizontalNavButton text-transform-initial"
            routerLinkActive="mat-secondary"
            [routerLink]="[item.id]"
            (click)="changePreselectedStatusTrackerId(item.id)"
            [attr.data-testId]="item.name"
          >
            {{item.name}}
          </button>
        </div>
      </app-horizontal-navigation>
    </ng-container>

    <ng-template #noStatusTrackers>
      <div class="px-spacer-responsive py-3 border-top">
        <i i18n="@@dprDetails.dprStatusTracker.txtNoActiveTabs">
          You have no active subtabs. Go to Project Setup -> Status Tracker in order to add or activate any.
        </i>
      </div>
    </ng-template>

    <ng-template #handsetTemplate>
      <app-navigation-select
        [items]="statusTrackers | mapNavigationMenuItem : 'id' : 'name' : 'id'"
        [initialSelection]="preselectedStatusTrackerId"
        (selectedItemChanges)="changePreselectedStatusTrackerId(+($event))"
      ></app-navigation-select>
    </ng-template>
  </ng-container>
</ng-container>

<router-outlet (activate)="componentActivated($event)" (deactivate)="componentDeactivated()"></router-outlet>
